import React from "react";
import { type Props } from "./Factory";

const CustomItemFlow = (props: Props) => (
    <iframe
        title="itemFlow custom"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen={true}
        src={props.flow.commandAction.props.url}
    />
);

CustomItemFlow.displayName = "ItemFlowsInput.Custom";
export default CustomItemFlow;
